import React from 'react';
import { Outlet } from 'react-router-dom';

export const Credentials: React.FC = () => {
  return <Outlet />;
};
